<template>
    <section class="detail-inner">
        <div class="movie-player-wrap">
            <div class="category-div" v-if="category_list != undefined">
                <span class="cat_1" v-if="category1!=''">{{ getCategoryTitle('category1') }}</span><span class="cat_2" v-if="category2!=''">{{ getCategoryTitle('category2') }}</span>
                <span class="cat_1" v-if="category1=='' && category2==''">全て</span>
            </div>
            <div class="player">
                <video id="video01" class="video-js vjs-default-skin vjs-big-play-centered vjs-16-9" data-setup="{}" controls preload="auto" autoplay>
            </div>

            <p class="player__category">{{ item_title }}</p>
            <div class="player_data flex" v-if="contents.length">
                <p class="play__title"><span>{{ content_title }}</span></p>
                <div class="fav_addition" v-if="contents[playing_number].favorite_status==0" @click="addFavoriteList(playing_number)"><button><span>お気に入り追加</span></button></div>
                <div class="fav_addition fev_del" v-if="contents[playing_number].favorite_status==1" @click="removeFavoriteList(playing_number)"><button><span>お気に入り解除</span></button></div>
            </div>
        </div>

        <div class="movie-select-wrap">
            <p class="movie-select__title">曲を選ぶ</p>

            <ul class="detail-movie-list list__player">
                <li v-for="(content, index) in contents" :key="index">
                    <a @click="jump(content.digicon_id)" class="movie_title" :class="{ 'play_all': index === 0 }">{{ content.title }}</a>
                    <button class="icn_fav" v-if="content.favorite_status==0" @click="addFavoriteList(index)"></button>
                    <button class="icn_fav at_fev" v-if="content.favorite_status==1" @click="removeFavoriteList(index)"></button>
                </li>
            </ul>
        </div>

    </section>
</template>

<script>
    import 'video.js/dist/video-js.css';
    import videojs from 'video.js/dist/video.js';
    export default {
        name: "tmariko-video-player",
        props: {
            item_id: {
                type: String,
                default: '0',
            },
            digicon_id: {
                type: String,
            },
            category1: {
                type: String,
                default: '',
            },
            category1_child: {
                type: String,
                default: '',
            },
            category2: {
                type: String,
                default: '',
            },
            category2_child: {
                type: String,
                default: '',
            },
            play_type: {
                type: String,
                default: 'video',
            },
        },
        data: function () {
            return {
                video: undefined,
                content_title: '',
                item_title: '',
                contents: [],
                playing_number: Number,
                getAlbumInfoPath: '',
                getContentInfoPath: '',
                playStartSec: 0,
                recordedFlag: false,
                finFlag: false,
                sample_flag: 0,
                category_list: undefined,
            }
        },
        mounted() {
            this.getAlbumInfoPath = '/purchased/digicon/detail/'+this.item_id;
            this.getContentInfoPath = '/digicon/content/';

            this.video = videojs("video01", {html5: {
                }},
            );
            this.setVideoConfig();
            axios.default
                .post(this.getAlbumInfoPath, {type: 'content'})
                .then(response => {
                    let contents = response.data;
                    for(let i=0; i<contents.length; i++) {
                        this.$set(this.contents, i, contents[i]);
                    }
                    this.jump(this.digicon_id);
            });
            this.getCategoryList();
        },
        methods: {
            play: function() {
                if(this.finFlag) {
                    this.finFlag = false;
                    this.playing_number = 0;
                    this.setDigicon(this.playing_number);
                    return;
                }
                this.video.play();
                this.resetPlayingSec();
            },
            stop: function() {
                this.video.pause();
            },
            setVideoConfig: function() {
                this.video.on('loadedmetadata', function() {
                    this.recordedFlag = false;
                    this.recordContentsPlayLog();
                    this.play();
                }.bind(this));
                this.video.on('timeupdate', function() {
                    this.recordPlayLog();
                }.bind(this));
                this.video.on('ended', function() {
                    this.forward();
                }.bind(this));
            },
            setDigiconConfig: function(path) {
                this.video.src(path);
            },
            setDigicon: function(playing_number) {
                this.content_title = this.contents[playing_number].title;
                let digicon_id = this.contents[playing_number].digicon_id;
                this.item_title = this.contents[playing_number].item_title;
                axios.default
                    .get(this.getContentInfoPath+digicon_id)
                    .then(response => {
                        let data = response.data;
                        let playing_path = data.fname;
                        this.setDigiconConfig(playing_path);
                    });
            },
            forward: function() {
                this.stop();
                if(this.contents.length-1 <= this.playing_number) {
                    this.finFlag = true;
                    return;
                } else {
                    this.playing_number++;
                }
                this.setDigicon(this.playing_number);
            },
            jump: function(digicon_id) {
                this.stop();
                let index = 0;
                for(let content of this.contents) {
                    if(content.digicon_id == digicon_id) {
                        this.playing_number = index;
                        this.setDigicon(this.playing_number);
                        break;
                    }
                    index++;
                }
            },
            resetPlayingSec: function() {
                this.playStartSec = performance.now();
            },
            recordPlayLog: function() {
                if(!this.checkPlayingSec()) return;
                if(this.recordedFlag) return;
                this.recordedFlag = true;
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .post('/player/log/add', {digicon_id: digicon_id})
                    .then(response => {
                        if(response.data.status=='error') {
                            this.recordedFlag = false;
                        }
                    });
            },
            recordContentsPlayLog: function() {
                let digicon_id = this.contents[this.playing_number].digicon_id;
                axios.default
                    .get('/playlog/content/add/'+digicon_id, {sample_flag: this.sample_flag})
                    .then(response => {
                        if(!response.data[0].log_id) {
                            console.log('fail record playlog');
                        }
                    });
            },
            checkPlayingSec: function() {
                if(performance.now() - this.playStartSec < 46000) return false;
                return true;
            },
            addFavoriteList: function(index) {
                let digicon_id = this.contents[index]['digicon_id'];
                axios.default
                    .get('/favorite/content/add/'+digicon_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 1;
                        this.contents[index]['favorite_id'] = res.favorite_id;
                    });
            },
            removeFavoriteList: function(index) {
                let favorite_id = this.contents[index]['favorite_id'];
                axios.default
                    .get('/favorite/content/remove/'+favorite_id)
                    .then(response => {
                        let res = response.data[0];
                        if(res.error_message) {
                            return;
                        }
                        this.contents[index]['favorite_status'] = 0;
                        this.contents[index]['favorite_id'] = undefined;
                    });
            },
            getCategoryList: function() {
                axios.default
                    .get(`/item/category/list/get?type=${this.play_type}`)
                    .then(response => {
                        this.category_list = response.data;
                    });
            },
            getCategoryTitle: function(category_type) {
                let category_num;
                let child_num;
                switch(category_type) {
                    case 'category1':
                        category_num = this.category1;
                        child_num = this.category1_child;
                        break;
                    case 'category2':
                        category_num = this.category2;
                        child_num = this.category2_child;
                        break;
                }
                if(category_num=='') {
                    return '全て';
                }
                const category_list = this.category_list[category_type];
                const category = category_list.find(element => element.id == category_num);
                if(category) {
                    const child = category['child'].find(element => element.id == child_num);
                    if(child) {
                        return child.title;
                    }
                    return category.title;
                }
                return '';
            },
        },
    }
</script>

<style scoped>
</style>
